import { defaultMeta } from '@/constants/defaultMeta';
import { parseDateRangeSearch } from '@/lib/parseDateRange';
import { sortBy } from '@/lib/sortBy';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { customersQueries } from '@/services/customers/customers.queries.ts';
import { useSearch } from '@tanstack/react-router';

export const useCustomersList = () => {
  const search = useSearch({ from: '/(app)/users/customers/' });
  const { page, fetch, createdDate, q } = search;
  const parsedCreatedDate = parseDateRangeSearch(createdDate, { start: 0, end: 0 });

  const { data, isFetched, isLoading } = useQuery({
    ...customersQueries.list({
      row: page,
      fetch: fetch,
      search: q ?? '',
      fromDate: parsedCreatedDate?.start,
      toDate: parsedCreatedDate?.end,
    }),
    select: (res) => ({
      ...res,
      data: sortBy(res.data, search.sort),
    }),
    enabled: !!fetch,
  });

  return {
    customers: data?.data || [],
    isFetched,
    meta: data?.meta?.pagination || defaultMeta,
    isLoading,
  };
};
